<!-- Layout principal com cards de segurança no topo e formulário centralizado -->
<div class="reset-password-container" #resetPasswordContainer>
  <!-- Cards de segurança no topo -->
  <div class="security-cards-section">
    <div class="security-cards-container">
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="lock-outline" status="success"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Segurança de Dados</h3>
          <p>Seus dados estão protegidos com criptografia de ponta a ponta e protocolos de segurança avançados.</p>
        </div>
      </div>
      
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="lock-outline" status="primary"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Proteção de Privacidade</h3>
          <p>Conformidade com LGPD e políticas rigorosas de proteção à privacidade dos usuários.</p>
        </div>
      </div>
      
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="award-outline" status="warning"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Experiência e Credibilidade</h3>
          <p>Mais de 10 anos de experiência em soluções financeiras, imobiliárias e pecuárias com foco em segurança e confiança.</p>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Formulário de reset de senha centralizado -->
  <div class="reset-password-section">
    <div class="reset-password-form">
      <div class="system-title">
        <h1 class="title">Nova Senha</h1>
        <h2 class="system-name">Reno Inteligência</h2>
      </div>
      <p class="sub-title">Digite o código de verificação enviado para seu e-mail</p>
      <p class="description">Código enviado para: <strong>{{ user.email }}</strong></p>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Erro</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>

      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Sucesso!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>

      <!-- Formulário de reset de senha -->
      <form *ngIf="!showMessages.success" (ngSubmit)="resetPassword()" #form="ngForm" aria-labelledby="title">
        
        <!-- Campo do código de verificação -->
        <div class="form-control-group">
          <label class="label" for="input-code">Código de Verificação:</label>
          <input nbInput
                 fullWidth
                 [(ngModel)]="user.code"
                 #code="ngModel"
                 name="code"
                 id="input-code"
                 type="text"
                 maxlength="6"
                 pattern="[0-9]{6}"
                 placeholder="000000"
                 fieldSize="large"
                 autofocus
                 required
                 [attr.aria-invalid]="code.invalid && code.touched ? true : null"
                 tabindex="1">
          <ng-container *ngIf="code.invalid && code.touched">
            <p class="caption status-danger" *ngIf="code.errors?.required">
              Código é obrigatório!
            </p>
            <p class="caption status-danger" *ngIf="code.errors?.pattern">
              O código deve conter apenas 6 números!
            </p>
          </ng-container>
        </div>

        <!-- Campo da nova senha -->
        <div class="form-control-group">
          <label class="label" for="input-password">Nova Senha:</label>
          <nb-form-field>
            <input nbInput
              fullWidth
              [(ngModel)]="user.password"
              #password="ngModel"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              id="input-password"
              placeholder="Digite sua nova senha"
              fieldSize="large"
              [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
              required
              minlength="6"
              [attr.aria-invalid]="password.invalid && password.touched ? true : null"
              tabindex="2">
            <button nbSuffix nbButton ghost 
              status="basic"
              type="button"
              (click)="togglePasswordVisibility()" 
              tabindex="-1"
              class="password-toggle-btn"
              [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
              <nb-icon [icon]="showPassword ? 'eye-off-2-outline' : 'eye-outline'"
                      pack="eva">
              </nb-icon>
            </button>
          </nb-form-field>

          <ng-container *ngIf="password.invalid && password.touched">
            <p class="caption status-danger" *ngIf="password.errors?.required">
              Nova senha é obrigatória!
            </p>
            <p class="caption status-danger" *ngIf="password.errors?.minlength">
              A senha deve ter pelo menos 6 caracteres!
            </p>
          </ng-container>
        </div>

        <!-- Campo de confirmação da senha -->
        <div class="form-control-group">
          <label class="label" for="input-confirm-password">Confirmar Nova Senha:</label>
          <nb-form-field>
            <input nbInput
              fullWidth
              [(ngModel)]="user.confirmPassword"
              #confirmPassword="ngModel"
              name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="input-confirm-password"
              placeholder="Confirme sua nova senha"
              fieldSize="large"
              [status]="confirmPassword.dirty ? (confirmPassword.invalid ? 'danger' : 'success') : 'basic'"
              required
              [attr.aria-invalid]="confirmPassword.invalid && confirmPassword.touched ? true : null"
              tabindex="3">
            <button nbSuffix nbButton ghost 
              status="basic"
              type="button"
              (click)="toggleConfirmPasswordVisibility()" 
              tabindex="-1"
              class="password-toggle-btn"
              [attr.aria-label]="showConfirmPassword ? 'Ocultar senha' : 'Mostrar senha'">
              <nb-icon [icon]="showConfirmPassword ? 'eye-off-2-outline' : 'eye-outline'"
                      pack="eva">
              </nb-icon>
            </button>
          </nb-form-field>

          <ng-container *ngIf="confirmPassword.invalid && confirmPassword.touched">
            <p class="caption status-danger" *ngIf="confirmPassword.errors?.required">
              Confirmação de senha é obrigatória!
            </p>
          </ng-container>
        </div>

        <button nbButton
                fullWidth
                status="primary"
                size="large"
                [disabled]="submitted || !form.valid"
                [class.btn-pulse]="submitted"
                tabindex="4"
                class="reset-password-btn">
          {{ submitted ? 'Processando...' : 'Alterar Senha' }}
        </button>
      </form>

      <!-- Botões de navegação -->
      <div class="navigation-buttons">
        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="resendCode()"
                [disabled]="submitted"
                class="resend-code-btn">
          <nb-icon icon="refresh-outline" pack="eva"></nb-icon>
          Reenviar Código
        </button>

        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="goBackToRequestPassword()"
                class="back-btn">
          <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
          Voltar
        </button>

        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="goBackToLogin()"
                class="login-btn">
          <nb-icon icon="log-in-outline" pack="eva"></nb-icon>
          Ir para Login
        </button>
      </div>

      <!-- Informações adicionais -->
      <div class="additional-info">
        <p class="info-text">
          <nb-icon icon="info-outline" status="info"></nb-icon>
          <span>O código de verificação foi enviado para o e-mail cadastrado em sua conta.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="clock-outline" status="warning"></nb-icon>
          <span>O código expira em 5 minutos por questões de segurança.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="shield-outline" status="success"></nb-icon>
          <span>Não compartilhe este código com ninguém.</span>
        </p>
      </div>
    </div>
  </div>
</div>
